"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Ripple = _styledComponents["default"].div.attrs(function (props) {
  return {
    colour: props.colour ? props.colour : props.theme.admin.colors.brand
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n\n    div {\n        position: absolute;\n        border: 4px solid ", ";\n        opacity: 1;\n        border-radius: 50%;\n        animation: ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n    }\n\n    div:nth-child(2) {\n        animation-delay: -0.5s;\n    }\n\n    @keyframes ripple {\n        0% {\n            top: 36px;\n            left: 36px;\n            width: 0;\n            height: 0;\n            opacity: 1;\n        }\n        100% {\n            top: 0px;\n            left: 0px;\n            width: 72px;\n            height: 72px;\n            opacity: 0;\n        }\n    }\n"])), function (props) {
  return props.colour;
});

var LoadingIcon = function LoadingIcon(_ref) {
  var colour = _ref.colour;
  return /*#__PURE__*/_react["default"].createElement(Ripple, {
    colour: colour
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null));
};

var _default = LoadingIcon;
exports["default"] = _default;